/** Walzen-Symbole */
export enum GameSymbol {
  STAR = 'STAR',
  MOON = 'MOON',
  HORSESHOE = 'HORSESHOE',
  HEART = 'HEART',
  CROWN = 'CROWN',
  CLOVER = 'CLOVER',
}

/** Alle verfügbaren Symbole als Array */
export const ALL_SYMBOLS: GameSymbol[] = [
  GameSymbol.STAR,
  GameSymbol.MOON,
  GameSymbol.HORSESHOE,
  GameSymbol.HEART,
  GameSymbol.CROWN,
  GameSymbol.CLOVER,
];

/** Kombinations-Typen */
export enum ComboType {
  THREE_CLOVERS = 'THREE_CLOVERS',
  THREE_MOONS = 'THREE_MOONS',
  THREE_HEARTS = 'THREE_HEARTS',
  THREE_STARS = 'THREE_STARS',
  THREE_CROWNS = 'THREE_CROWNS',
  THREE_HORSESHOES = 'THREE_HORSESHOES',
  ONE_PAIR = 'ONE_PAIR',
  JOKER = 'JOKER',
  FULL_HOUSE = 'FULL_HOUSE',
  FIVE_DIFFERENT = 'FIVE_DIFFERENT',
  FOUR_OF_A_KIND = 'FOUR_OF_A_KIND',
  FIVE_OF_A_KIND = 'FIVE_OF_A_KIND',
}

/** Alle Kombinations-Typen als Array (Reihenfolge: links->rechts, oben->unten) */
export const ALL_COMBOS: ComboType[] = [
  ComboType.THREE_CLOVERS,
  ComboType.THREE_MOONS,
  ComboType.THREE_HEARTS,
  ComboType.THREE_STARS,
  ComboType.THREE_CROWNS,
  ComboType.THREE_HORSESHOES,
  ComboType.ONE_PAIR,
  ComboType.JOKER,
  ComboType.FULL_HOUSE,
  ComboType.FIVE_DIFFERENT,
  ComboType.FOUR_OF_A_KIND,
  ComboType.FIVE_OF_A_KIND,
];

/** Spieler-Status */
export enum PlayerStatus {
  WAITING = 'WAITING',
  READY = 'READY',
  PLAYING = 'PLAYING',
  FINISHED = 'FINISHED',
  DISCONNECTED = 'DISCONNECTED',
}

/** Raum-Status */
export enum RoomStatus {
  WAITING = 'WAITING',
  PLAYING = 'PLAYING',
  ROUND_END = 'ROUND_END',
  GAME_END = 'GAME_END',
}
